var _a;
import { buildEventHandler } from '../Provider/Provider.events';
export var notify = (_a = buildEventHandler(), _a.dispatch), subscribe = _a.subscribe;
//# sourceMappingURL=notify.js.map